import { useMediaCompanyThematicContentBlocksLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useCompanyThematicContentBlocks = () => {
  const [request, result] = useMediaCompanyThematicContentBlocksLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const loadCompanyThematicBlocks = (companyId: string) =>
    request({
      variables: {
        companyId,
      },
    });

  return {
    request: loadCompanyThematicBlocks,
    error: result.error,
    loading: result.loading,
    items: result.data?.result || [],
  };
};

export default useCompanyThematicContentBlocks;
